export const getters = {
  getUserData: state => state.userData,
  getConnectionStatus: state => state.connectionStatus,
  getQueue: state => state.queue,
  getTags: state => state.tags,
  getCategories: state => state.categories,
  getExpressStatuses: state => state.expressStatuses,
  getExpressRegional: state => state.expressRegional,
  getExpressAssociate: state => state.expressAssociate,
  getExpressBilletSituation: state => state.expressBilletSituation,
  getUserMessage: state => state.userMessage,
  getNewConnectionWapi: state => state.newConnectionWapi,
};
